module.exports = __webpack_public_path__ + "images/emoji/u6307.407831ef5ea768a4a6b4.png";